module.exports = __webpack_public_path__ + "static/media/calculus-i-completed.80bb5ee3.svg";